// components/NewInvoice/InvoiceItemTypeTabs.jsx
import React from "react";
import { FaPlus } from "react-icons/fa";

const TabBtn = ({ value, current, onClick, children }) => {
  const active = current === value;
  return (
    <button
      type="button"
      onClick={() => onClick(value)}
      className={`px-2 sm:px-3 py-1.5 rounded-lg text-sm font-medium border ${
        active
          ? "bg-[#9481ce] text-white border-[#9481ce]"
          : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
      }`}
    >
      {children}
    </button>
  );
};

const InvoiceItemTypeTabs = ({
  value,
  onChange,
  className = "",
  handleAddRow,
}) => {
  return (
    <div className={`inline-flex gap-2 ${className}`}>
      <TabBtn value="ornaments" current={value} onClick={onChange}>
        <span className="hidden sm:inline">Stocks</span>

        <span
          onClick={(e) => {
            e.stopPropagation();
            handleAddRow?.();
          }}
          title="Add stock row"
          className="inline-flex sm:ml-2 h-4 w-4 items-center justify-center rounded-full bg-sky-500 text-white"
        >
          <FaPlus className="text-[10px]" />
        </span>
      </TabBtn>
      {/* <TabBtn value="loose" current={value} onClick={onChange}>
        Loose Stone
      </TabBtn>
      <TabBtn value="looseDiamond" current={value} onClick={onChange}>
        Loose Diamond
      </TabBtn> */}
    </div>
  );
};

export default InvoiceItemTypeTabs;
